import React from 'react';
import { alertError, alertSuccess } from '../config/toast';
import { getcategoryReq, mastersSubcategoryReq, addInMastersSubcategoryReq, removeFromMasterCategoryReq } from '../config/httpRoutes';
import { Row, Form, Col, Card, Button, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCross, faFill, faFilter, faPlus, faRemoveFormat, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import Loader from '../components/loader';


class CatProd extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			catid: this.props.match?.params?.id || '',
			product: '',
			allCatprods: null,
			catprods: null,
			category: {},
			products: null,
			search: '',
			errors: { product: '' },
			loading: false,
			deleteLoading: false,
			fetchLoading: true,
			id: '',
		};
	}

	componentDidMount() {
		this.catProds();
		this.getPreReqs();
	}

	catProds = () => {
		this.setState({ fetchLoading: true });
		mastersSubcategoryReq({ category: this.props.match?.params?.id, search: this.state.search })
			.then((res) => {
				const { category, supplies: catprods } = res.data;
				this.setState({ category, allCatprods: catprods, catprods });
			}).catch((err) => {
				alertError(err.response?.data?.msg || "Could not fetch products");
			}).finally(() => {
				this.setState({ fetchLoading: false });
			});
	}

	getPreReqs = async () => {
		try {
			const products = (await getcategoryReq()).data;
			console.log("DATAPRE", products)
			this.setState({
				products
			});
		} catch (err) {
			alertError("Could not fetch required data");
		}
	}

	searchProducts = (search) => {
		this.setState({ fetchLoading: true });
		mastersSubcategoryReq({ category: this.props.match?.params?.id, search })
			.then((res) => {
				const { category, supplies: catprods } = res.data;
				this.setState({ category, allCatprods: catprods, catprods, form: false, search });
			}).catch((err) => {
				alertError(err.response?.data?.msg || "Could not fetch products");
			}).finally(() => {
				this.setState({ fetchLoading: false });
			});
	};


	filterSelected = () => {
		const { allCatprods } = this.state;
		this.setState({ catprods: allCatprods.filter((cp) => cp.catted) });
	}

	clearFilter = () => {
		const { allCatprods } = this.state;
		this.setState({ catprods: allCatprods });
	}

	inCat = (subcategory_id) => {
		const { catid: category_id } = this.state;
		this.setState({ loading: true });
		addInMastersSubcategoryReq({ category_id, subcategory_id })
			.then((res) => {
				this.setState({ loading: false });
				alertSuccess("Product added to category");
				this.catProds();
			}).catch((err) => {
				this.setState({ loading: false });
				alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
			});
	}

	outCat = (subcategory_id, index) => {
		this.setState({ deleteLoading: true });
		removeFromMasterCategoryReq({ category_id: this.state.catid, subcategory_id })
			.then((res) => {

				alertSuccess("Product removed from category");
				this.catProds();
			}).catch((err) => {
				alertError(err.response?.data?.msg || "Could not remove product from category");
			}).finally(() => {
				this.setState({ deleteLoading: false });
			});
	}

	render() {
		const { catid, product, products, catprods, category, deleteLoading, errors, loading, fetchLoading, form } = this.state;
		const { outCat, inCat, filterSelected, clearFilter, searchProducts } = this;
		return (
			<Row style={{ marginTop: '20px', marginLeft: 0, marginRight: 0, paddingLeft: '10%', paddingRight: '10%', paddingTop: '5%' }}>
				{/* Adjusted Search Box */}
				<Col md={6} className="d-flex justify-content-start">
					<Form.Control
						type="text"
						placeholder="Search products..."
						onChange={(e) => searchProducts(e.target.value)}
						style={{
							maxWidth: '100%', // Takes full width in the column
							minWidth: '250px', // Minimum width for better responsiveness
							padding: '8px 10px'
						}}
					/>
				</Col>
				<Col md={12} style={{ justifyContent: 'space-between', display: 'flex', marginTop: '10px', marginBottom: '15px' }}>
					<Card.Title>{category?.name}</Card.Title>
					<div>
						<Button variant="success" onClick={filterSelected} size="md" style={{ marginRight: "1rem" }}>
							<FontAwesomeIcon icon={faFilter} /> Filter Selected
						</Button>
						<Button variant="success" onClick={clearFilter} size="md">
							<FontAwesomeIcon icon={faFill} /> Clear Filter
						</Button>
					</div>
				</Col>
				{fetchLoading && <Loader />}
				{Array.isArray(catprods) ?
					catprods.length > 0 ?
						<>
							<Row>
								{catprods.map(({ id, name, price, image, description, /* quantity, */ catted }, i) =>
									<Col md={{ span: 3 }} key={i}>
										<Card className="d-flex justify-content-between flex-row p-2">
											<h3>{name}</h3>
											<div className="course-control-box icons-container d-flex align-self-center">
												{catted ?
													<OverlayTrigger overlay={<Tooltip>Delete</Tooltip>} delay={{ show: 150, hide: 150 }}>
														<FontAwesomeIcon icon={faTrashAlt} className="disabled-icon font-16 cursor-pointer" style={{ color: 'red' }} onClick={(e) => { outCat(id, i) }} />
													</OverlayTrigger>
													:
													<OverlayTrigger overlay={<Tooltip>Add</Tooltip>} delay={{ show: 150, hide: 150 }}>
														<FontAwesomeIcon icon={faPlus} className="disabled-icon font-16 cursor-pointer" style={{ color: 'green' }} onClick={(e) => { inCat(id, i) }} />
													</OverlayTrigger>
												}
											</div>
										</Card>
									</Col>
								)}
							</Row>
						</>
						:
						<p style={{ position: 'fixed', marginLeft: '34%', marginTop: '20%' }}>No sub-category in this category.</p>
					:
					<></>
				}
			</Row>
		);
	}
}

export default CatProd;